module.exports = __webpack_public_path__ + "img/food-21.7c1129cd.jpg";